// This file can be replaced during the build/deployment process
const config = {
  apiUrl: process.env.REACT_APP_API_URL || 'http://localhost:8000'
};

export default config;
